import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, SubscriptionPaymentTerm } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useCompanySubscriptionPaymentTermsQuery(
	companyGuid?: Guid | undefined,
	subscriptionGuid?: Guid | undefined,
	options?:
		| Omit<
				UseQueryOptions<SubscriptionPaymentTerm[], unknown, SubscriptionPaymentTerm[], any>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Company.PaymentTerms(companyGuid, subscriptionGuid),
		() =>
			AxiosUtils.getResponseData<SubscriptionPaymentTerm[]>(
				api.get(CerebroApiEndpoints.Company.PaymentTerms(companyGuid, subscriptionGuid))
			),
		options
	);
}
